import { findProblems, type HealthNode } from "@tanstack/db";
import { ApiError } from "@softmax/observatory-client/transport";

export function collectionError(health: HealthNode | undefined): Error | null {
  if (!health) return null;

  const problems = findProblems(health).flatMap((node) => {
    const problem = node.error ?? node.failureReason;
    return problem ? [problem, ...problem.errors] : [];
  });
  const newestProblems = problems
    .toReversed()
    .toSorted((left, right) => right.at - left.at);
  const causes = newestProblems.map((problem) => problem.cause);
  const denied = causes.find(
    (cause) =>
      cause instanceof ApiError &&
      (cause.status === 401 || cause.status === 403),
  );

  if (denied instanceof ApiError) return denied;

  const apiError = causes.find((cause) => cause instanceof ApiError);

  if (apiError instanceof ApiError) return apiError;

  const error = causes.find((cause) => cause instanceof Error);

  if (error instanceof Error) return error;

  const problem = newestProblems[0];
  return problem ? new Error(problem.message, { cause: problem.cause }) : null;
}

export function collectionRefreshing(health: HealthNode | undefined): boolean {
  return (
    health !== undefined &&
    (health.reloading || health.sources.some(collectionRefreshing))
  );
}
